import { Pipe, PipeTransform } from '@angular/core';
import { ITimelineEntity } from '@common/dialogs/intersection-dialog/types/intersection-dialog.types';

@Pipe({ name: 'isTimelineEntityBusy' })
export class IsTimelineEntityBusyPipe implements PipeTransform {
  transform(entities: ITimelineEntity[]): boolean {
    return entities.some((e) => e.isBusy);
  }
}
